import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Dispatch } from 'redux';
import { handleActivityStatus, handleCalibrationStatus } from '../../actions/activities.actions';
import { mean, std } from '../../utils/statistics';

interface CalibrationProps extends WithTranslation{    
    dispatch: Dispatch<any>,
    callback: any,
    sensorData:Array<number>,
    calibrationStatus: string,
    ready: boolean,
}

interface CalibrationState {
    calibrationData: number[];
}

class Calibration extends Component<CalibrationProps, CalibrationState> {
    private sensorDataArray: number[] = [];
    private userWeight: number = 0;
    private addedWeights: number = 0;

    constructor(props: CalibrationProps) {
        super(props);
        this.state = {
            calibrationData: [],
        };
    }

    componentDidUpdate(prevProps: CalibrationProps) {
        if(this.props.ready && this.props.calibrationStatus == 'request'){
            this.props.dispatch(handleCalibrationStatus('pending'));
            this.sensorDataArray = this.props.sensorData;
            this.calibration();
        }
        
        if(this.props.sensorData[0] != prevProps.sensorData[0]){
            if(this.props.calibrationStatus=='error' && this.props.sensorData[this.props.sensorData.length-1] ==0){
                this.props.dispatch(handleCalibrationStatus('user stepped out'));
            }
            
        }
    }

    calibration() {
        if (this.sensorDataArray.length > 10) {
            const avgWeight = mean(this.sensorDataArray);
            const weightVariation = std(this.sensorDataArray);
            
            if (weightVariation < 10 && avgWeight > 0) {
                this.userWeight = avgWeight;
                const addWeights = this.userWeight > 100;
                
                if(!addWeights){
                    this.props.dispatch(handleActivityStatus('wait start'));
                    this.props.dispatch(handleCalibrationStatus('success'));
                    this.props.callback(this.userWeight, this.addedWeights);
                    this.userWeight=0;
                    this.addedWeights=0;
                }
                else{
                    this.props.dispatch(handleCalibrationStatus('stop'));
                }
            } else if (std(this.sensorDataArray) > 10 || mean(this.sensorDataArray) === 0) {
                this.sensorDataArray = [];
                this.props.dispatch(handleCalibrationStatus('error'));
            } else {
                this.sensorDataArray = [];
                this.props.dispatch(handleCalibrationStatus('error'));
                //this.props.dispatch(handleCalibrationStatus('failed'));
            }
        }
    }

    startCalibration(){
        this.props.dispatch(handleCalibrationStatus('request'));
        this.sensorDataArray = [];
    }

    render() {
        const { t, calibrationStatus, ready } = this.props;
        
        if (!ready) {
            return null;
        }

        return (
            <div className="calibration-container">
                <div className="calibration-status">
                    <h3>{t('calibration.title')}</h3>
                    <p>{t(`calibration.status.${calibrationStatus}`)}</p>
                </div>
                
                {calibrationStatus === 'request' && (
                    <button 
                        className="start-calibration-btn"
                        onClick={this.startCalibration}
                    >
                        {t('calibration.start')}
                    </button>
                )}
                
                {calibrationStatus === 'pending' && (
                    <div className="calibration-progress">
                        <p>{t('calibration.standStill')}</p>
                        <div className="progress-bar">
                            <div 
                                className="progress-fill" 
                                style={{width: `${Math.min((this.sensorDataArray.length / 10) * 100, 100)}%`}}
                            />
                        </div>
                        <span>{this.sensorDataArray.length}/10 samples</span>
                    </div>
                )}
                
                {calibrationStatus === 'success' && (
                    <div className="calibration-success">
                        <p>{t('calibration.success')}</p>
                        <p>{t('calibration.weight')}: {this.userWeight.toFixed(1)} kg</p>
                    </div>
                )}
                
                {calibrationStatus === 'error' && (
                    <div className="calibration-error">
                        <p>{t('calibration.error')}</p>
                        <button onClick={this.startCalibration}>
                            {t('calibration.retry')}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    calibrationStatus: state.activities.calibrationStatus,
    activityStatus: state.activities.activityStatus,
});

export default withTranslation('workout')(connect(mapStateToProps)(Calibration))